/* =============================================================
   APP CONFIG
   =============================================================
   Product-level facts for the admin panel. Deliberately much
   smaller than the main app's: this tool is internal, so there
   is no white-label story and nothing here is env-overridable.
   ============================================================= */

export const appConfig = {
  name: 'River Atlas Admin',
  /** Shown in the sidebar wordmark, where "Admin" is a separate pill. */
  shortName: 'River Atlas',

  urls: {
    app: 'https://app.riveratlas.eu',
    marketing: 'https://riveratlas.eu',
  },

  titleTemplate: '%s · River Atlas Admin',

  storageKeys: {
    /** supabase-js owns its own session key; this is only ours. */
    sidebarCollapsed: 'river-atlas-admin.sidebar-collapsed',
  },
} as const
